module.exports = __webpack_public_path__ + "img/img2.155d3014.png";